<template>
  <v-dialog
    :model-value="value"
    width="500px"
    content-class="dependency-tree-feedback-modal"
    @click:outside="closeModal"
  >
    <BaseDialogCard :title="tkey('modalTitle')" @close="closeModal">
      <v-container fluid class="pa-0">
        <v-row class="d-flex flex-column main-container border-0 mb-0">
          <v-col class="pl-0 pb-0 pt-0 pr-4 content">
            <p class="mb-4">
              {{ tkey(`pageInfo.${page}`) }}
            </p>
            <p class="mb-4">{{ tkey('proceedText') }}:</p>

            <hr class="mb-2" />

            <p v-for="result in results" :key="result.name" class="result-item">
              {{ result.count }}
              {{ normalizeTranslation(`dependencyTree.types.${result.name}`, t) }}
              {{ tkey(result.action) }}
            </p>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="warningMessage" class="divider-top pt-3 px-2 pb-0 ma-0 mt-4">
        <v-alert variant="tonal" class="mb-1">
          {{ $t(warningMessage) }}
        </v-alert>
      </v-container>
      <template #footer>
        <PageActions
          :has-data-errors="hasDataErrors"
          :has-data-changes="true"
          :show-discard="false"
          :save-btn-text="saveBtnText"
          :proceed-btn-text="proceedBtnText"
          :show-proceed-button="ableToProceedWithoutDeleting"
          @proceed="onSaveWithoutDeleting"
          @save="onSave"
        >
          <template #right-btns>
            <v-btn class="text-outline font-weight-bold" variant="text" @click="closeModal">
              {{ $t('actions.cancel') }}
            </v-btn>
          </template>
        </PageActions>
      </template>
    </BaseDialogCard>
  </v-dialog>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    results: {
      type: Object,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    saveBtnText: {
      type: String,
      required: false,
      default: 'confirmDownstreamChanges',
    },
    proceedBtnText: {
      type: String,
      required: false,
      default: 'proceed',
    },
    ableToProceedWithoutDeleting: {
      type: Boolean,
      required: false,
      default: false,
    },
    warningMessage: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup() {
    const { tkey, t, normalizeTranslation } = useInternationalization('dependencyTree');
    return { tkey, t, normalizeTranslation };
  },

  data() {
    return {};
  },
  computed: {
    hasDataErrors() {
      return false;
    },
  },
  methods: {
    closeModal(params) {
      this.$emit('close', params);
    },
    onSaveWithoutDeleting() {
      this.$emit('proceed');
      this.closeModal();
    },
    onSave() {
      this.$emit('commit');
      this.closeModal('afterSave');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.sub-title {
  font-size: 1.2rem;
  font-weight: bold;
}

.main-container {
  border-bottom: 1px solid $assortment-divider-colour;
  max-height: 350px;
  overflow-y: auto;
  flex-basis: auto;
  font-size: 1.3rem;
}

:deep(.dialog-card__footer) {
  border-top-width: 0px;
}

:deep(.v-alert) {
  background: $assortment-warning-alert-background !important;
  border: 1px solid $assortment-warning-alert-border !important;
  border-radius: 0 !important;
  padding: 14px;

  &:before {
    content: none;
  }

  .v-alert__content {
    color: $assortment-text-colour;
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
}

.result-item:not(:last-child) {
  margin-bottom: 16px;
}
</style>
